import React from 'react';

import {Link} from 'react-router-dom';

import config from "./typeConfig";
import i18n from "../../i18n";

export default function Error({status, img, desc = i18n.t('components.error.message')}) {

    const pageStatus = status in config ? status : 500;
    const imgStyle = {backgroundImage: `url('${img || config[pageStatus].img}')`};

    return (
        <div className="exception">
            <div className="imgBlock">
                <div className="imgEle" style={imgStyle}/>
            </div>
            <div className="content">
                <h1>{pageStatus}</h1>
                <div className="desc">{desc}</div>
                <div className="actions">
                    <Link to="/">{i18n.t('components.error.link')}</Link>
                </div>
            </div>
        </div>
    );
}
